<template>
    <div id="cart">
        <div class="box" id="cart-container">
            <!--<router-link to="/" id="btn-close" ref="btn-close"><img src="@/assets/img/x_24.png"></router-link>-->
            <a href="#" id="btn-close" ref="btn-close" v-on:click="exit"><img src="@/assets/img/x_24.png"></a>
            <h1 v-text="$ml.get('cart.title')"></h1>
            <h3>{{ $ml.get('cart.meus_itens') }}({{ counter }})</h3>
            <div class="info" v-if="!shoppingCart.length && !loading" v-html="$ml.get('cart.nenhum_produto')"></div>
            <div class="info" v-if="loading" v-html="$ml.get('cart.carregando_itens')"></div>
            <ul>
                <li v-for="i in this.shoppingCart" :key="i.id">
                    <ul>
                        <li>
                            <!--<img :src="$url + 'produtos/' + i.id + '.webp'" width="70">-->

                            <img :src="$url_oracle + i.thumb" width="70">
                        </li>
                        <li>{{ i.description }}</li>
                        <!--<li>Quantidade: {{ i.quantity }}</li>-->
                        <li>
                            <ul>
                                <li><a class="less" v-on:click="decrement" :data-id="i.id">-</a></li>
                                <li id="product-count">{{ i.quantity  }}</li>
                                <li><a class="more" v-on:click="increment" :data-id="i.id">+</a></li>
                            </ul>
                        </li>
                        <li style="text-align: center">
                            <div v-bind:class="{ fm : (i.sale_price), riscado:(i.sale_price)  }">$ {{ String(i.price.toFixed(2)).replace(".", ",") }}</div>
                            <div v-if="i.sale_price" class="boldt">$ {{ String(i.sale_price.toFixed(2)).replace(".", ",") }}</div>
                        </li>
                        <li>$ {{ String(i.amount.toFixed(2)).replace(".", ",") }}</li>
                        <li><a class="icon-trash" href="#" v-on:click="del" :data-id="i.id" :title="$ml.get('cart.excluir_item')"><img src="@/assets/img/trash.png"></a></li>
                    </ul>
                </li>
            </ul>

            <input id="product_temp" name="product_temp" ref="product_temp" type="hidden" value="" style="display: none">
            <div id="cart-change-open" v-if="change_cart_open">

                <ul>
                    <li><a class="btn-0" href="#" v-on:click="cartChangeDiscard" v-text="$ml.get('cart.descartar')"></a></li>
                    <li><a class="btn-1" href="#" v-on:click="cartChangeSave" v-text="$ml.get('cart.confirmar')"></a></li>
                </ul>
            </div>
            <hr>
            <div id="cart-info" v-bind:class="{ 'cart-change-blocked': this.change_cart_open }">
                <ul>
                    <li>
                        <ul>
                            <li><h3 v-text="$ml.get('cart.tipo_entrega')"></h3></li>
                            <li>
                                <button class="btn-0" type="button" v-bind:class="{ 'active': (delivery === 'home') }" v-on:click="deliveryHandler" data-v="home" v-text="$ml.get('cart.em_casa')"></button>
                                <button class="btn-0" type="button" v-bind:class="{ 'active': (delivery === 'store') }" v-on:click="deliveryHandler" data-v="store" v-text="$ml.get('cart.retirada_loja')"></button>
                                <button class="btn-0" type="button" v-bind:class="{ 'active': (delivery === 'locker') }" v-on:click="deliveryHandler" data-v="locker" v-text="$ml.get('cart.pickup_in_locker')"></button>
                                <div id="locker-address" ref="locker-address">

                                </div>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <ul>
                            <li><h3 v-text="$ml.get('cart.pagamento')"></h3></li>
                            <li>
                                <ul>
                                    <li style="text-align: left">{{ $ml.get('cart.cartao_credito') }}<br><br><b>**** **** **** 3788</b></li>
                                    <li>
                                        {{ $ml.get('cart.utilizar_pontos') }}<br>
                                        <b>{{ points }}</b>
                                        <div class="checkbox-container" style="display: inline-block;margin-left: 15px">
                                            <input class="styled-checkbox" type="checkbox" name="remember" id="remember" v-on:change="pointHandler">
                                            <label class="form-check-label" for="remember"></label>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <ul>
                                    <li v-text="$ml.get('cart.total_compra')"></li>
                                    <li><b>$ {{ String(Number(total).toFixed(2)).replace(".", ",") }}</b></li>
                                    <li v-if="this.point_checked" style="vertical-align: middle">{{ $ml.get('cart.utilizacao_de_pontos')}} <b>{{ point_value }}</b></li>
                                    <li v-if="this.point_checked" style="vertical-align: middle">
                                        <!--<input id="point-field" ref="point-field" min="0" :max="(points > total ? Math.floor(total) : points)" readonly placeholder="Pontos" style="width: 100px;height: 40px" type="number" value="0" v-model="point_value" v-on:keyup="checkInputValue" v-on:change="pointInputHandler">-->
                                        <input id="point-field" ref="point-field" min="0" :max="(points > total ? Math.floor(total) : points)" readonly placeholder="Pontos" style="width: 100px;height: 40px" type="text" value="0" v-model="point_value" v-on:keyup="checkInputValue" v-on:change="pointInputHandler">
                                    </li>
                                    <li v-text="$ml.get('cart.total_pagar')"></li>
                                    <li><b>$ {{ String(Number(total_temp).toFixed(2)).replace(".", ",") }}</b></li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div id="cart-controller" v-bind:class="{ 'cart-change-blocked': this.change_cart_open }">
                <ul>
                    <li><button class="btn-0" type="button" v-on:click="clearCart" v-text="$ml.get('cart.esvaziar_carrinho')"></button></li>
                    <li><a class="btn-1" v-on:click="checkOutStart" v-text="$ml.get('cart.pagar')"></a></li>
                </ul>
            </div>
        </div>

        <div v-if="stores_active" id="stores">
            <div class="box" id="stores-container">
                <ul>
                    <li><h3>{{ $ml.get('cart.escolha_cidade') }}</h3></li>
                    <li>
                        <select name="locationId" id="locationId">
                            <option value="">{{ $ml.get('cart.escolha_cidade') }}</option>
                            <option  v-for="i in this.stores" :key="i.locationId" :value="i.locationId">{{ i.address1 + ' - ' + i.city }}</option>
                        </select>
                    </li>
                    <li><button class="btn-1" type="button"  v-on:click="storeChoice">{{ $ml.get('cart.choice') }}</button></li>
                    <li><button class="btn-0" type="button" v-on:click="storeCancel">{{ $ml.get('cart.cancel') }}</button></li>
                </ul>
            </div>
        </div>


    </div>
</template>

<script>
    import axios from 'axios';
    import {mapActions, mapGetters} from "vuex";
    export default {
        name: "Carrinho",
        computed: {
            ...mapGetters([
                'counter', 'token', 'logged', 'products', 'products_ids', 'products_n', 'points', 'id', 'email', 'first_name', 'last_name'
            ])
        },
        data() {
            return {
                change_cart_open: false,
                count           : 0,
                delivery        : 'home',
                error           : null,
                l_              : null,
                loading         : false,
                location_id     : null,
                point_checked   : false,
                point_value     : 0,
                shippingGroups  : [],
                shoppingCart    : [],
                stores          : [],
                stores_active   : false,
                total           : 0,
                total_temp      : 0
            }
        },
        methods: {
            ...mapActions([
                'update', 'update_cart', 'update_cart_products', 'del_product_cart', 'update_points'
            ]),

            exit(e) {
                if (this.change_cart_open) {
                    this.cartChangeDiscard(null);
                }
                this.$router.push('/');
                if (e)
                    e.preventDefault();
            },

            /*----- locker -----*/
            getLocker(e) {
                this.$parent.wait(true);
                let form_data = new FormData();
                form_data.append('token', this.token);
                form_data.append('sku', this.products_ids[this.count]);
                axios.post(this.$url + 'dist/php/locker.php', form_data).then(response => this.getLockerResponse(response));
                if (e)
                    e.preventDefault();
            },
            getLockerResponse(obj) {
                this.$parent.wait(false);
                if (obj.data.availability == 'true') {
                    this.checkout();
                } else {
                    alert(this.$ml.get('cart.alert_locker'));
                }
            },
            /*----- \locker\ -----*/



            /*----- stock -----*/
            getStock(e) {
                this.$parent.wait(true);
                let form_data = new FormData();
                form_data.append('token', this.token);
                form_data.append('sku', this.products_ids[this.count]);
                axios.post(this.$url + 'dist/php/stock.php', form_data).then(response => this.getStockResponse(response));
                if (e)
                    e.preventDefault();
            },
            getStockResponse(obj) {
                this.$parent.wait(false);

                if (Number(obj.data[0].quantity) < Number(this.products_n[this.count]))
                {
                    alert(this.$ml.get('cart.alert1_stock') + obj.data[0].location.address.address1 + this.$ml.get('cart.alert2_stock') + obj.data[0].quantity + this.$ml.get('cart.alert3_stock') + this.products[this.count].description + '".');
                }
                else
                {
                    this.count++;
                    if (this.count < this.products_ids.length)
                    {
                        this.getStock();
                    }
                    else
                    {
                        this.getLocker();
                    }
                }
            },
            /*----- \stock\ -----*/



            /*----- getStore -----*/
            storeChoice(e) {
                e;
                this.location_id = document.getElementById('locationId').value;
                this.stores_active = false;
            },
            storeCancel(e) {
                e;
                this.location_id = null;
                this.stores_active = false;
            },
            getStore(e) {
                this.$parent.wait(true);
                let form_data = new FormData();
                axios.post(this.$url + 'dist/php/get_store.php', form_data).then(response => this.getStoreResponse(response));
                if (e)
                    e.preventDefault();
            },
            getStoreResponse(obj)
            {
                this.$parent.wait(false);
                this.stores = obj.data.items;
                this.stores_active = true;
                
            },
            /*----- \getStore\ -----*/

            /*----- cart-change -----*/
            cartChangeDiscard(e) {
                this.shoppingCart = JSON.parse(this.$refs['product_temp'].value);
                for (let o in this.shoppingCart) {
                    this.update_cart_products(this.shoppingCart[o]);
                }
                this.$forceUpdate();
                this.refreshTotal();
                this.change_cart_open = false;
                this.$refs['product_temp'].value = '';
                if (e)
                    e.preventDefault();
            },
            cartChangeSave(e) {
                this.updateCartLocal(null);
                e.preventDefault();
            },
            increment(e) {
                if (!this.change_cart_open) {
                    this.$refs['product_temp'].value = JSON.stringify(this.products);
                }
                this.change_cart_open = true;
                let index = this.products_ids.indexOf(e.currentTarget.getAttribute("data-id"));
                this.shoppingCart[index].quantity++;
                this.shoppingCart[index].amount = ((this.shoppingCart[index].sale_price ? this.shoppingCart[index].sale_price : this.shoppingCart[index].price) * this.shoppingCart[index].quantity);
                this.$forceUpdate();
                this.update_cart_products(this.shoppingCart[index]);
                this.refreshTotal();
                e.preventDefault();
            },
            decrement (e) {
                let index = this.products_ids.indexOf(e.currentTarget.getAttribute("data-id"));
                if (this.shoppingCart[index].quantity > 1) {
                    if (!this.change_cart_open) {
                        this.$refs['product_temp'].value = JSON.stringify(this.products);
                    }
                    this.change_cart_open = true;
                    this.shoppingCart[index].quantity--;
                    this.shoppingCart[index].amount = ((this.shoppingCart[index].sale_price ? this.shoppingCart[index].sale_price : this.shoppingCart[index].price) * this.shoppingCart[index].quantity);
                    this.$forceUpdate();
                    this.update_cart_products(this.shoppingCart[index]);
                    this.refreshTotal();
                }
                e.preventDefault();
            },
            /*----- \cart-change\ -----*/


            deliveryHandler(e) {
                this.delivery = e.currentTarget.getAttribute("data-v");
                if (this.delivery == 'store')
                {
                    this.getStore();
                }
                else
                {
                    this.location_id = null;
                }
                if (this.delivery == 'locker')
                {
                    this.$refs['locker-address'].style.display = 'block';
                    this.$refs['locker-address'].innerText = 'Rua Jaceru, 225\nVila Gertrudes\nSão Paulo - SP, 04705-000'
                }
                else
                {
                    this.$refs['locker-address'].style.display = 'none';
                    this.$refs['locker-address'].innerText = '';
                }
                e.preventDefault();
            },

            checkInputValue(e) {
                if ((e.currentTarget.value > this.points) || (e.currentTarget.value > Number(this.total))) {
                    this.point_value = 0;
                    e.currentTarget.value = 0;
                    alert(this.$ml.get('cart.alert_points'));
                    return false;
                }
            },
            pointInputHandler(e) {
                this.total_temp = (this.total - this.point_value).toFixed(2);

                if (e)
                    e.preventDefault();
            },
            pointHandler(e) {
                //console.log(this.points, this.total);
                if (this.points >= this.total) {
                    this.point_checked = true;
                    
                    this.point_value = this.total;

                    this.total_temp = (this.total - this.point_value).toFixed(2);
                } else {
                    e.currentTarget.checked = false;
                    this.point_checked = false;
                    alert(this.$ml.get('cart.alert1_points'));
                }
                //this.point_checked = e.currentTarget.checked;
                e.preventDefault();
            },

            clearCart(e) {
                this.$parent.wait(true);
                let form_data = new FormData();
                form_data.append('token', this.token);
                form_data.append('id', this.id);
                axios.post(this.$url + 'dist/php/clear_cart.php', form_data).then(response => this.clearCartResponse(response));
                if (e)
                    e.preventDefault();
            },
            clearCartResponse(obj) {
                //console.log(obj, obj.status);
                if (obj.data.errorCode)
                {
                    this.$parent.logOut(null);
                    alert(obj.data.message);
                }
                else
                {
                    if (obj.status === 200) {
                        this.update_cart_products(null);
                        this.shippingGroups = [];
                        this.shoppingCart = [];
                        this.total = 0;
                        this.total_temp = 0;
                        this.point_value = 0;
                    } else {
                        alert(this.$ml.get('cart.alert_error_cart_clear'));
                    }
                }
                this.$parent.wait(false);
            },
            refreshTotal() {
                let c = 0;
                for (let o in this.products) {
                    //c += (this.products[o].amount);
                    c += ((this.products[o].sale_price ? this.products[o].sale_price : this.products[o].price) * this.products[o].quantity);

                }
                this.total = c.toFixed(2);
                this.pointInputHandler();
            },




            /*----- get-cart -----*/
            //com cache
            /*getCart() {
                if (this.products.length === 0) {
                    this.loading = true;
                    let form_data = new FormData();
                    form_data.append('token', this.token);
                    axios.post(this.$url + 'php/get_cart.php', form_data).then(response => this.getCartResponse(response));
                } else {
                    this.shoppingCart = this.products;
                    this.refreshTotal();
                }
            },
            getCartResponse(obj) {
                if (obj.data.error) {
                    this.error = obj.data.error;
                } else {
                    if (obj.data) {
                        //this.shippingGroups = obj.data.shippingGroups[0].items;
                        //this.shoppingCart = obj.data.shoppingCart.items;

                        this.total = obj.data.priceInfo.amount;
                        this.pointInputHandler();

                        this.shoppingCart = [];
                        for (let o in obj.data.shoppingCart.items) {
                            this.l_ = { id:obj.data.shoppingCart.items[o].productId, quantity:obj.data.shoppingCart.items[o].quantity, description:obj.data.shoppingCart.items[o].displayName, price:obj.data.shoppingCart.items[o].price, orderId:obj.data.orderId, amount:obj.data.priceInfo.amount  };
                            this.shoppingCart.push(this.l_);
                            this.update_cart_products(this.l_);
                        }

                    }
                }
                this.loading = false;
            },*/

            //sem cache
            getCart() {
                this.loading = true;
                let form_data = new FormData();
                form_data.append('token', this.token);
                form_data.append('l', this.$ml.current);
                axios.post(this.$url + 'dist/php/get_cart.php', form_data).then(response => this.getCartResponse(response));
            },
            getCartResponse(obj) {
                if (obj.data.errorCode)
                {
                    this.$parent.logOut(null);
                    alert(obj.data.message);
                }
                else
                {
                    if (obj.data) {

                        this.update_cart_products(null);
                        this.shippingGroups = [];
                        this.shoppingCart = [];
                        this.total = 0;
                        this.total_temp = 0;
                        this.point_value = 0;


                        this.total = obj.data.priceInfo.amount;
                        this.pointInputHandler();

                        this.shoppingCart = [];
                        for (let o in obj.data.shoppingCart.items) {
                            //this.l_ = { id:obj.data.shoppingCart.items[o].productId, thumb:obj.data.shoppingCart.items[o].primaryThumbImageURL, quantity:obj.data.shoppingCart.items[o].quantity, description:obj.data.shoppingCart.items[o].displayName, price:obj.data.shoppingCart.items[o].listPrice, orderId:obj.data.orderId, amount:obj.data.shoppingCart.items[o].rawTotalPrice };
                            this.l_ = { id:obj.data.shoppingCart.items[o].productId, thumb:obj.data.shoppingCart.items[o].primaryThumbImageURL, quantity:obj.data.shoppingCart.items[o].quantity, description:obj.data.shoppingCart.items[o].displayName, price:obj.data.shoppingCart.items[o].listPrice, sale_price:obj.data.shoppingCart.items[o].salePrice, orderId:obj.data.orderId, amount:obj.data.shoppingCart.items[o].amount };
                            this.shoppingCart.push(this.l_);
                            this.update_cart_products(this.l_);
                        }
                    }
                }
                this.loading = false;
            },
            /*----- -----*/




            del (e) {
                let l_ = { id:e.currentTarget.getAttribute("data-id") };
                this.del_product_cart(l_);

                if (this.products_n.length > 0) {
                    this.updateCartLocal(null);
                } else {
                    this.clearCart(null);
                }
                e.preventDefault();
            },

            updateCartLocal(e) {
                this.$parent.wait(true);
                let form_data = new FormData();
                form_data.append('token', this.token);
                form_data.append('product_id', this.products_ids.join(","));
                form_data.append('product_n', this.products_n.join(","));
                axios.post( this.$url + 'dist/php/add_cart.php', form_data).then(response => this.updateCartResponse(response));

                if (e)
                    e.preventDefault();
            },
            updateCartResponse(obj) {
                obj;
                if (obj.data.errorCode)
                {
                    this.$parent.logOut(null);
                    alert(obj.data.message);
                }
                else
                {
                    this.shoppingCart = this.products;
                    this.$forceUpdate();
                    this.refreshTotal();
                    this.point_value = 0;
                    //console.log(obj);
                    this.change_cart_open = false;
                }
                this.$parent.wait(false);
            },
            checkOutStart(e) {
                if (this.delivery == 'locker') {
                    this.count = 0;
                    this.getStock();
                } else {
                    this.checkout(e);
                }

            },
            checkout (e) {
                if (this.total > 0) {
                    this.$parent.wait(true);
                    let form_data = new FormData();
                    form_data.append('token',         this.token);
                    form_data.append('id',            this.id);
                    form_data.append('email',         this.email);
                    form_data.append('first_name',    this.first_name);
                    form_data.append('last_name',     this.last_name);
                    form_data.append('product_id',    this.products_ids.join(","));
                    form_data.append('product_n',     this.products_n.join(","));
                    form_data.append('orderId',       this.products[0].orderId);
                    form_data.append('delivery_type', this.delivery);
                    form_data.append('total',         this.total);
                    form_data.append('locationId',    this.location_id);
                    form_data.append('_paymentWithPoints', document.getElementById('remember').checked);

                    axios.post(this.$url + 'dist/php/checkout.php', form_data).then(response => this.checkoutResponse(response));
                } else {
                    alert(this.$ml.get('cart.alert_value_pay'));
                }
                e.preventDefault();
            },
            checkoutResponse(obj) {
                this.$parent.wait(false);
                if (obj.data.errorCode)
                {
                    this.$parent.logOut(null);
                    alert(obj.data.message);
                }
                else
                {
                    this.update_cart_products(null);
                    this.shippingGroups = [];
                    this.shoppingCart = [];
                    if (obj.data.uuid) {
                        if (this.point_checked) {
                            this.deductPoints();
                        } else {
                            this.$router.push('/sucesso');
                        }
                    } else {
                        alert(this.$ml.get('cart.alert_error_buy') + '\n\n' + obj.data.message);
                    }
                }
            },

            deductPoints() {
                //console.log(this.point_checked, this.point_value);
                this.$parent.wait(true);
                let form_data = new FormData();
                form_data.append('token',  this.token);
                form_data.append('id',     this.id);
                form_data.append('points', this.point_value);
                axios.post(this.$url + 'dist/php/deduct_points.php', form_data).then(response => this.deductPointsResponse(response));
            },
            deductPointsResponse(obj) {
                this.$parent.wait(false);
                if (obj.data.error) {
                    //this.error = obj.data.error;
                    alert(this.$ml.get('cart.alert_info_error_discount_points') + obj.data.message);
                    this.exit();
                } else if (obj.data.ending_balance) {
                    this.$router.push('/sucesso');
                } else {
                    alert(this.$ml.get('cart.alert_error_buy'));
                }

            }
        },
        mounted() {
            this.getCart();
        }
    }
</script>

<style scoped>
    #locker-address
    {
        background-color: #f5f5f5;
        border-radius: 10px;
        box-sizing: border-box;
        display: none;
        padding: 10px;
    }
    #cart
    {
        background-color: rgba(0, 0, 0, .6);
        height: 100%;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 9999999999;
    }
    #cart-container
    {
        display: block;
        margin: 150px  auto;
        max-height: 80%;
        max-width: 800px;
        overflow-y: auto;
    }
    #cart-container > ul
    {
        box-sizing: border-box;
        padding: 15px 0;
    }
    #cart-container > ul > li > ul > li
    {
        box-sizing: border-box;
        display: inline-block;
        padding: 10px 15px;
        vertical-align: middle;
    }
    #cart-container > ul > li > ul > li:nth-child(1)
    {
        width: 10%;
    }
    #cart-container > ul > li > ul > li:nth-child(1) img
    {
        border: solid 1px #e5e5e5;
        border-radius: 10px;
    }
    #cart-container > ul > li > ul > li:nth-child(2)
    {
        width: 29%;
    }
    #cart-container > ul > li > ul > li:nth-child(3)
    {
        width: 22%;
    }
    #cart-container > ul > li > ul > li:nth-child(4)
    {
        width: 13%;
    }
    #cart-container > ul > li > ul > li:nth-child(5)
    {
        width: 13%;
    }
    #cart-container > ul > li > ul > li:nth-child(6)
    {
        width: 6%;
    }

    /*----- stores -----*/
    #stores
    {
        background-color: rgba(0, 0, 0, .7);
        height: 100%;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
    }
    #stores-container
    {
        height: auto;
        left: calc(50% - 225px);
        padding: 25px;
        position: fixed;
        top: 100px;
        width: 450px;
    }
    #stores-container > ul > li
    {
        box-sizing: border-box;
        list-style: none;
        padding: 10px 0;
    }
    #stores-container select
    {
        width: 100%;
    }
    /*----- \stores\ -----*/


    /*----- cart-container -----*/
    #cart-container > ul > li > ul > li > ul > li
    {
        box-sizing: border-box;
        cursor: pointer;
        display: inline-block;
        padding: 10px 0px;
        vertical-align: top;
    }
    .less, .more
    {
        background-color: black;
        border-radius: 10px;
        color: white;
        display: block;
        font-size: 25px;
        font-weight: bold;
        outline: none;
        height: 40px;
        line-height: 40px;
        text-align: center;
        user-select: none;
        width: 40px;
    }
    #product-count
    {
        color: #e55944;
        font-size: 35px;
        font-weight: bold;
        height: 50px;
        text-align: center;
        width: 50px;
    }
    /*----- \cart-container\ -----*/


    #cart-controller
    {
        box-sizing: border-box;
        padding: 10px;
        text-align: center;
        width: 100%;
    }
    #cart-controller > ul > li
    {
        box-sizing: border-box;
        display: inline-block;
        padding: 0 5px;
        width: calc((100% / 2) - 30px);
    }


    /*----- cart-change-open -----*/
    #cart-change-open
    {
        text-align: center;
    }
    #cart-change-open > ul > li
    {
        box-sizing: border-box;
        list-style: none;
        display: inline-block;
        padding: 5px;
        text-align: center;
    }
    .cart-change-blocked
    {
        opacity: .3;
        pointer-events: none;
    }
    /*----- cart-change-open -----*/



    /*----- cart-info -----*/
    #cart-info > ul > li
    {
        display: inline-block;
        vertical-align: top;
        width: calc(100% / 2);
    }
    #cart-info > ul > li > ul >  li
    {
        box-sizing: border-box;
        display: block;
        padding: 10px;

    }
    #cart-info > ul > li:nth-child(1) > ul > li > button
    {
        border-radius: 10px;
        margin: 5px;
        width: calc(50% - 20px);
    }
    #cart-info > ul > li > ul >  li > ul > li
    {
        box-sizing: border-box;
        display: inline-block;
        padding: 6px;
        vertical-align: top;
        width: calc(100% / 2);
    }
    #cart-info > ul > li > ul >  li > ul > li:nth-child(even)
    {

    }
    #cart-info > ul > li > ul >  li > ul > li:nth-child(odd)
    {
        text-align: right;
    }

    #cart-info > ul > li > ul >  li > ul > li > span
    {
        font-size: 10px;
    }
    /*----- \cart-info\ -----*/


    h1
    {
        box-sizing: border-box;
        text-align: center;
        padding: 10px 0;
    }
    h3
    {
        font-weight: normal;
    }

    #btn-close
    {
        box-sizing: border-box;
        float: right;
        padding: 15px;
    }
    .info{
        box-sizing: border-box;
        padding: 10px;
    }
    .active
    {
        border: none;
        color: white !important;
        background-color: #fea044;
    }
    @media screen and (max-width: 850px)
    {
        #cart-container
        {
            width: calc(100% - 40px);
        }
        #cart-container > ul > li
        {
            border-bottom: solid 1px #e5e5e5;
        }
        #cart-container > ul > li > ul > li
        {

            display: block;
            text-align: center;
            width: 100% !important;
        }
        #cart-container > ul > li > ul > li > img
        {
            width: 150px;
        }

        #cart-info > ul > li
        {

            display: block;
            text-align: center;
            width: 100% !important;
        }
        #cart-info > ul > li:nth-child(1) > ul > li > button
        {
            width: 100%;
        }

        .icon-trash
        {
            border: solid 1px #ccc;
            box-shadow: 2px 2px 0 rgba(0, 0, 0, .1);
            box-sizing: border-box;
            display: inline-block;
            padding: 10px;
        }
    }
</style>